export default {
  title: 'Reçu imprimé',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Masquer les frais de service sur le reçu',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Masquer la section prix sur le reçu',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Masquer les noms de groupes de modificateurs sur le reçu',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
  },
};
